import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { observer } from "mobx-react-lite";
import { PositionedSpinner } from "../../../../../components/ui/PositionedSpinner";
import { useParams } from "react-router-dom";
import { ProjectPlacesModel } from "./ProjectMap_model";
import { ClusteredPlaceMarkers } from "./components/ClusteredProjectPlace";

export type Poi = {
  key: number;
  name: string;
  country: string;
  city: string;
  streetAddress: string;
  place: google.maps.LatLngLiteral;
  projectNames: string;
  totalProjects: number;
  totalProjectProcesses: number;
  totalImpacts: number;
  totalAudienceStakeholders: number;
  totalProjectStakeholders: number;
  projectIds: number[];
  projectId: number;
};

export const Places: React.FC = observer(() => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams<{ projectId: string }>();
  const [model] = useState(() => new ProjectPlacesModel(organisationId, +projectId));
  const API_KEY = (window as any).appConfig.google_Maps_Api_Key; // TODO: update api key

  useEffect(() => {
    model.onMount();
    //eslint-disable-next-line
  }, []);

  if (model.isLoading) return <PositionedSpinner />;

  return (
    <APIProvider apiKey={API_KEY}>
      <Map
        style={{
          width: "calc(100vw - 127px)",
          height: "50vh",
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor: "gray"
        }}
        defaultCenter={{ lat: 35.1264, lng: 33.4299 }}
        defaultZoom={3}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        mapId="DEMO_MAP_ID"
      >
        <ClusteredPlaceMarkers places={model.places} />
      </Map>
    </APIProvider>
  );
});
